<template xmlns="http://www.w3.org/1999/html">
<div :style="{'max-height': timeLineHeight + 'px'}"
    style="overflow-y: scroll">
  <el-card>
    <el-form ref="taskReleaseForm" :model="taskReleaseForm" label-width="260px">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="请选择任务类型" prop="taskType">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                请选择任务类型
              </span>
            <el-select v-model="taskReleaseForm.taskType" clearable placeholder="请选择" @change="taskTypeChange">
              <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.taskName"
                  :value="parseInt(item.id)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="请选择店铺" prop="shopInfo">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                请选择店铺
              </span>
            <el-select v-model="taskReleaseForm.shopInfo" clearable placeholder="请选择">
              <el-option
                  v-for="spItem in allShops"
                  :key="spItem.id"
                  :label="spItem.shopName"
                  :value="spItem.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="text" @click="addShops">
            <i class="el-icon-plus"></i>
            <span>添加店铺</span>
          </el-button>
        </el-col>
      </el-row> -->
      <!-- 新增商返还是平台返 -->
      <!-- <el-row :gutter="5" v-show="enableBusinessReturnMoney">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="本金返款" prop="baseMoneyReturnType">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                本金返款
              </span>
            <el-radio-group v-model="taskReleaseForm.baseMoneyReturnType">
              <el-radio :label="false">平台&nbsp;&nbsp;(手续费: 根据配置按笔收取，本金和佣金由平台返款)</el-radio>
              <el-radio :label="true">商家&nbsp;&nbsp;(本金由商家通过试客提交付款截图付款，佣金由平台返款)</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- end -->
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">设置商品信息</span>
      </div>
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="任务名称" prop="taskName">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                任务名称
              </span>
            <el-input v-model="taskReleaseForm.taskName" placeholder="请用类目+产品(例如：男装夹克)"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="宝贝链接" prop="productUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝基础链接
              </span>
            <el-input v-model="taskReleaseForm.productUrl" placeholder="请填写正确的宝贝链接,长度500以内" maxlength="500" show-word-limit></el-input>
            <!-- <div v-show="isShowGetLinkBtn" style="color: red">确保商家掌柜号一致。
            </div> -->
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4" v-show="isShowGetLinkBtn">
          <el-button type="text" @click="getTaobaoGood(null)">
            <i class="el-icon-refresh"></i>
            <span>获取宝贝数据</span>
          </el-button>
        </el-col> -->
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="宝贝标题" prop="productUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝数量
              </span>
            <el-input v-model="taskReleaseForm.goodTitle" placeholder="请填写宝贝标题"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="宝贝主图" prop="goodImgUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝主图
              </span>
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleAvatarSuccess"
                :on-remove="handleAvatarRemove">
              <div v-if="taskReleaseForm.goodImgUrl">
              <img :src="taskReleaseForm.goodImgUrl" class="avatar">
              <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemove(taskReleaseForm.goodImgUrl)"></i>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：上传“宝贝主图”，确保与搜索页面展示的图片一致 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row> 
      <!-- <div v-show="isNotBrowserOrder(taskReleaseForm.taskType)"> -->
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="宝贝价格(元)" prop="businessPrice">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                宝贝价格(元)
              </span>
            <el-input v-model="taskReleaseForm.businessPrice" placeholder="请输入宝贝价格"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：用户拍下时的付款价格，如不同等级买号看到商品价格不同，取最大值   </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="每单怕(件)" prop="billProductNum">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                每单怕(件)
              </span>
            <el-input v-model="taskReleaseForm.billProductNum" placeholder="请输入每天拍件数"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：总金额 {{
                  isNaN(parseInt(taskReleaseForm.billProductNum) * parseFloat(taskReleaseForm.businessPrice)) ? 0 : parseInt(taskReleaseForm.billProductNum) * parseFloat(taskReleaseForm.businessPrice)
                }} 元 【不含运费】 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      </div>
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="搜索价格(元)" prop="sreachPrice">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                搜索价格(元)
              </span>
            <el-input type="number" v-model="taskReleaseForm.sreachPrice" placeholder="请输入搜索价格"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：务必亲自在手机端搜索，确认价格准确 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="isNotBrowserOrder(taskReleaseForm.taskType)">
      <el-row :gutter="5">
        <el-col :span="24">
          <el-row :gutter="2" style="line-height: 33px;margin-left: 20%;font-size: 0.8rem">
            <el-col :span="2" style="text-align: right;">
              <span class="blink">多链接</span>
            </el-col>
            <el-col :span="4" style="padding-left: 1rem;">
              <el-button type="text" style="color: red;font-size: 0.8rem;margin-top: -3px" @click="addGoods">
                <i class="el-icon-plus"></i>
                添加商品({{moreLinkPrice}}金/条)
              </el-button>
            </el-col>
            <el-col :span="9" style="padding-left: 1.2rem">
              <div style="color: red;width: 100%;text-align: left;">
                <i class="el-icon-question"></i>
                <span>提示：添加一起购买的商品(最多5个)</span>
              </div>
            </el-col>
            <el-col :span="3">
              <span>小计：<span style="color: red">{{ taskReleaseForm.goodPriceTotal }}</span>元</span>
            </el-col>
          </el-row>
          <el-row :gutter="2" style="margin-top:1%;display: flex;align-items: center;" v-if="goodsTableVisible"
                  v-for="(goodItem, index) in taskReleaseForm.goodsAry" :key="index">
            <el-col :span="15" class="boxself">
              <el-row :gutter="0" style="margin: 2%;display: flex;align-items: center;">
                <el-col :span="6">
                  <el-upload
                      class="itemCls"
                      action="https://api.weiquanai.com/taskservice/file/upload"
                      :headers="myheader"
                      :show-file-list="false"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      :on-success="handleGoodSuccess.bind(null, {index: index, data:goodItem})"
                      :on-remove="handleAvatarRemove">
                    <div v-if="goodItem.goodImageUrl">
                    <img :src="goodItem.goodImageUrl" class="avatar">
                     <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveLink(goodItem)"></i>
                    </div>
                    <i v-else class="el-icon-plus"></i>
                  </el-upload>
                </el-col>
                <el-col :span="17" style="margin-left: 4%;font-size: 0.6rem">
                  <el-row :gutter="0">
                    <el-col :span="17">
                      <el-form-item label="链接" prop="goodItem.goodUrl" label-width="23%">
                        <el-input v-model="goodItem.goodUrl"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-button type="danger" size="mini" @click="getTaobaoGood(goodItem)"
                                 style="margin: 5%; margin-top: 1%;">
                        <i class="el-icon-refresh"></i>
                        <span>获取数据</span>
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="17">
                      <el-form-item label="关键词" prop="goodItem.mainKey" label-width="23%">
                        <el-input v-model="goodItem.mainKey"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="17">
                      <el-form-item label="标题" prop="goodItem.goodTitle" label-width="23%">
                        <el-input v-model="goodItem.goodTitle"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0">
                    <el-col :span="8">
                      <el-form-item label="单价" prop="goodItem.goodPrice" label-width="33%">
                        <el-input v-model="goodItem.goodPrice"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="数量" prop="goodItem.goodNum" label-width="33%">
                        <el-input v-model="goodItem.goodNum"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="规格" prop="goodItem.goodRule" label-width="33%">
                        <el-input v-model="goodItem.goodRule"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="2">
              <el-button type="danger" icon="el-icon-delete" circle style="margin: 5%;"
                         @click="removeGood(goodItem)"></el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="领劵链接" prop="couponUrl">
            <el-input v-model="taskReleaseForm.couponUrl" placeholder="优惠券领取链接"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：优惠券链接 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="是否包邮" prop="freeShipping">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                是否包邮
              </span>
            <el-radio-group v-model="taskReleaseForm.freeShipping">
              <el-radio :label="false">不包邮</el-radio>
              <el-radio :label="true">包邮</el-radio>
            </el-radio-group>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：商品是否包邮！ </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-if="!taskReleaseForm.freeShipping">
        <el-col :span="24">
          <el-form-item label="快递费" prop="logisticsCompany">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                快递费
              </span>
            <el-input type="number" v-model="taskReleaseForm.expressMoney" placeholder="试客垫付快递费"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：试客下单垫付的快递费用，完成任务返还。 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="24">
          <el-form-item label="物流" prop="logisticsCompany">
              <span slot="label">
                <span style="color: red; font-size:small" v-show="taskReleaseForm.isFreeShipping">
                  必填
                </span>
                物流
              </span>
            <el-select v-model="taskReleaseForm.logisticsCompany" clearable placeholder="请选择">
              <el-option
                  v-for="item in allExpress"
                  :key="item.id"
                  :label="item.expressName"
                  :value="item.expressNumber"
              >
              </el-option>
            </el-select>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：礼品单物流上线，真实发货，买家真实签收！ </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      </div>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">设置如何找到商品</span>
      </div>
      <div v-if="isNotDouyinOrder(taskReleaseForm.taskType)">
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="商品排序方式" prop="goodsSortType">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                商品排序方式
              </span>
            <el-radio-group v-model="taskReleaseForm.goodsSortType">
              <el-radio :label="0">综合</el-radio>
              <el-radio :label="1">销量</el-radio>
            </el-radio-group>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：强烈建议销量排序，商品位置更稳定更好找 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5" v-show="isQrcodeTask">
        <el-col :span="24">
          <el-form-item label="二维码信息" prop="goodImgUrl">
              <span slot="label">
                <span style="color: red; font-size:small">
                  必填
                </span>
                二维码信息
              </span>
            <el-upload
                class="avatar-uploader"
                action="https://api.weiquanai.com/taskservice/file/upload"
                :headers="myheader"
                :show-file-list="false"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                :on-success="handleQrcodeImageSuccess"
                :on-remove="handleAvatarRemove">
              <div  v-if="taskReleaseForm.qrcodeTaskImgUrl" >
              <img :src="taskReleaseForm.qrcodeTaskImgUrl" class="avatar">
              <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveQrcode(taskReleaseForm)"></i>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：上传“二维码”，确保二维码信息的正确 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="商品现有收货人数或付款人数约(人)" prop="recivePersons">
            <el-input type="number" v-model="taskReleaseForm.recivePersons" placeholder="人数"></el-input>
            <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>提示：此处为手机淘宝销量优先搜索列表页显示的收货人数 </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="12">
          <el-form-item label="价格区间">
            <el-input v-model="taskReleaseForm.startPrice"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="1" align="center"><span style="line-height: 40px;">-</span></el-col>
        <el-col :span="4">
          <el-input v-model="taskReleaseForm.endPrice"></el-input>
        </el-col>
        <el-col :span="2"><span style="line-height: 40px;">元</span></el-col>
        <div
            style="color: red;width: 100%;text-align: left;font-size: 0.8rem;margin-top: -1%;float: left;margin-left: 16.4rem;">
          <i class="el-icon-question"></i>
          <span>提示：如果商品不好找，强烈建议添加价格区间、商品所在地方便用户找到你的商品。</span>
        </div>
      </el-row>
      <el-row :gutter="5">
        <el-col :span="20">
          <el-form-item label="商品所在地" style="margin-top: 2%;">
            <v-distpicker only-province
                          :province = "taskReleaseForm.goodAddress"
                          @selected="onProvinceSelected"></v-distpicker>
          </el-form-item>
        </el-col>
      </el-row>
      </div>
      <div v-else>-->
        <!-- 抖音关键字-->
        <!-- <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="抖音关键字" prop="douyinKeyWord">
              <el-input v-model="taskReleaseForm.douyinKeyword" placeholder="请填写抖音号"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
                <i class="el-icon-question"></i>
                <span>提示：请填写正确的抖音关键字；抖音关键字，抖音号和抖音二维码必填一个 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- 抖音关键字 end -->
        <!-- <el-row :gutter="5">
          <el-col :span="20" style="margin-top: 5px;">
            <el-form-item label="抖音号" prop="shopUserName">
              <el-input v-model="taskReleaseForm.douyinAccount" placeholder="请填写抖音号"></el-input>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
                <i class="el-icon-question"></i>
                <span>提示：请填写正确的抖音号；抖音号和抖音二维码必填一个 </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="抖音/商品二维码" prop="goodImgUrl">
              <span slot="label">
                抖音/商品二维码
              </span>
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleDouyinImageSuccess"
                  :on-remove="handleAvatarRemove">
                <div v-if="taskReleaseForm.douyinImgUrl">
                <img  :src="taskReleaseForm.douyinImgUrl" class="avatar">
                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveDouyin(taskReleaseForm)"></i>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
                <i class="el-icon-question"></i>
                <span>提示：上传“抖音/商品二维码”，确保与扫码后能进入正确的页面；抖音号和抖音/商品二维码必填一个</span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div> -->
      <!-- <el-row :gutter="5">
        <el-col :span="21" style="margin-top: 5px;">
          <el-form-item label="宝贝详情问答(2-10个字)" prop="goodInfoAnswer">
            <el-input v-model="taskReleaseForm.goodInfoAnswer"></el-input>
            <span style="font-size: 0.8rem;">通过找到商家设置的问答来增加买手在商品页的停留时间<span style="color: red"> 【 了解如何设置】 </span></span>
          </el-form-item>
          <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem;margin-top: -2%;float: left;margin-left: 16.4rem;">
            <i class="el-icon-question"></i>
            <span>提示：请选中你的商品属性或商品详情中的某文字作为关键词，最少2个字，最多10个字，<br>不要输入标题符号、空格、特殊字符。</span>
          </div>
        </el-col>
      </el-row>
      <div v-show="isNotBrowserOrder(taskReleaseForm.taskType)">
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;">
          <el-form-item label="订单留言" prop="orderLeaveMessage">
            <el-input v-model="taskReleaseForm.orderLeaveMessage" placeholder="买家留言"></el-input>
            <div style="color: #ff0000;width: 100%;text-align: left;font-size: 0.8rem">
              <i class="el-icon-question"></i>
              <span>用户拍下商品所需要填写的买家留言；出于安全考虑不建议大批量使用  </span>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      </div>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">任务类型和单数</span>
      </div>
      <el-row :gutter="5">
        <el-col :span="24" style="padding-left: 6.3%">
          <div style="color: red;width: 100%;text-align: left;font-size: 0.8rem">
            <i class="el-icon-question"></i>
            <span>必须至少选择一项任务类型（勾选展开填写明细）</span>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="5" align="center" style="margin: 10px 0px;">
        <el-col :span="24">
          <el-row style="padding-left: 6.3%">
            <el-col :span="6" style="text-align: left;line-height: 20px;margin-right: 0.8rem">
              <el-checkbox v-model="taskReleaseForm.taskChecked" @change="taskChanged('taskAry')">普通任务(<span style="color: #04befe;margin: 2px;">{{getTaskClassMoney("20210001")}}</span>金/单)
              </el-checkbox>
            </el-col>
            <el-col :span="14">
              <div style="line-height:20px;color: red;width: 100%;text-align: left;font-size: 0.8rem">
                <i class="el-icon-question"></i>
                <span>默认为5星无评价内容，如需评价请备注，但不可规定评价内容 （不包含浏览单）</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="2" v-if="taskReleaseForm.taskChecked"
                  style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
            <el-col :span="24">
              <div>
                <el-row :gutter="0" class="keywordCls" align="middle" type="flex"
                        v-for="(it, index) in taskReleaseForm.taskAry" :key="it">
                  <el-col :span="6" v-show="!isQrcodeTask">
                    <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                          <span v-if="isNotBrowserOrder(taskReleaseForm.taskType)&&!isTaoTagOrder(taskReleaseForm.taskType)">下单关键词</span>
                          <span v-else-if="isTaoTagOrder(taskReleaseForm.taskType)">淘口令</span>
                          <span v-else>浏览单关键词</span>
                        </span>
                      <el-input v-model="it.orderKeys" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="添加单数" label-width="40%">
                      <el-input v-model="it.orderAdd"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="7" v-show="!isQrcodeTask">
                    <el-form-item label="备用关键词" label-width="48%">
                      <el-input v-model="it.orderBackKey" placeholder="(选填)备用关键词" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5" style="margin-right: 5px;">
                    <el-form-item label="，颜色尺码" label-width="48%">
                      <el-input v-model="it.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" style="padding-left: 3%;text-align: right" v-if="it.isShowRemove">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                               @click="removeOrderKeys('taskAry', it)"></el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="5">
                  <el-col :span="24">
                    <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                      <el-col :span="12" style="padding-left: 1rem;">
                        <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('taskAry')">
                          <i class="el-icon-plus"></i>
                          <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">添加淘口令</span><span v-else>添加关键词</span>
                        </el-button>
                      </el-col>
                      <el-col :span="12" style="line-height: 43px;">
                        <span>总计：<span style="color: red">{{ totalTaskContent }}</span>单</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row style="margin-bottom: 10px;" v-show="isNotBrowserOrder(taskReleaseForm.taskType)">
                  <el-col :span="6" style="text-align: right;line-height: 20px;margin-left: 2%;">
                    <el-checkbox v-model="taskReleaseForm.taskReviewChecked">只需5星好评，不需要文字评论</el-checkbox>
                  </el-col>
                  <el-col :span="14">
                    <div
                        style="line-height:20px;color: red;width: 100%;text-align: left;font-size: 0.6rem;margin-left: 5%;">
                      <i class="el-icon-question"></i>
                      <span>将在买手端提醒买手只提交好评 </span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div v-show="isNotBrowserOrder(taskReleaseForm.taskType)">
      <el-row :gutter="5" align="center" style="margin: 10px 0px;">
        <el-col :span="24">
          <el-row style="padding-left: 6.3%">
            <el-col :span="6" style="text-align: left;line-height: 20px;margin-right: 0.8rem">
              <el-checkbox v-model="taskReleaseForm.textChecked" @change="taskChanged('textAry')">指定文字好评任务(<span style="color: #04befe;margin: 2px;">{{getTaskClassMoney("20210002")}}</span>金/单)
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="2" v-if="taskReleaseForm.textChecked"
                  style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
            <el-col :span="24">
              <div>
                <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="(its, index) in taskReleaseForm.textAry" :key="index">
                  <el-col :span="6" v-show="!isQrcodeTask">
                    <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                          <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">淘口令</span><span v-else>下单关键词</span>
                        </span>
                      <el-input v-model="its.orderKeys" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="添加单数" label-width="35%">
                      <el-input v-model="its.orderAdd"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-show="!isQrcodeTask">
                    <el-form-item label="备用关键词" label-width="42%">
                      <el-input v-model="its.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="its.isShowRemove">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                               @click="removeOrderKeys('textAry', its)"></el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="5">
                  <el-col :span="24">
                    <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                      <el-col :span="12" style="padding-left: 1rem;">
                        <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('textAry')">
                          <i class="el-icon-plus"></i>
                          <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">添加淘口令</span><span v-else>添加关键词</span>
                        </el-button>
                      </el-col>
                      <el-col :span="12" style="line-height: 43px;">
                        <span>总计：<span style="color: red">{{ totalTextContent }}</span>单</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-row :gutter="2" align="middle" type="flex" v-if="taskReleaseForm.textContent">
                      <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                        <span style="font-size: smaller;margin: 5px;">设置文字好评内容</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0" class="contentCls" v-for="(subIt, index) in taskReleaseForm.textContentAry"
                            :key="index" v-if="taskReleaseForm.textContent">
                      <el-col :span="24">
                        <el-row :gutter="2">
                          <el-col :span="24"
                                  style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                            <span style="font-size: smaller;margin: 5px;">设置地{{ subIt.orderSort}}单文字好评内容</span>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="16">
                            <el-form-item label-width="1%">
                              <el-input v-model="subIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="20">
                            <el-form-item label-width="1%">
                              <el-input type="textarea" v-model="subIt.reviewContent"
                                        placeholder="(选填)完整的评价内容， 最多500个字。未填写则在买手端提醒买手自由发挥。"
                                        maxlength="500"
                                        show-word-limit></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="5" align="center" style="margin: 10px 0px;">
        <el-col :span="24">
          <el-row style="padding-left: 6.3%">
            <el-col :span="6" style="text-align: left;line-height: 20px;margin-right: 0.8rem">
              <el-checkbox v-model="taskReleaseForm.imageChecked" @change="taskChanged('imageAry')">指定图文好评任务(<span style="color: #04befe;margin: 2px;">{{getTaskClassMoney("20210003")}}</span>金/单)
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="2" v-if="taskReleaseForm.imageChecked"
                  style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
            <el-col :span="24">
              <div>
                <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="(itl,index) in taskReleaseForm.imageAry" :key="index">
                  <el-col :span="6" v-show="!isQrcodeTask">
                    <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">淘口令</span><span v-else>下单关键词</span>
                        </span>
                      <el-input v-model="itl.orderKeys"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="添加单数" label-width="35%">
                      <el-input v-model="itl.orderAdd"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-show="!isQrcodeTask">
                    <el-form-item label="备用关键词" label-width="42%">
                      <el-input v-model="itl.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="itl.isShowRemove">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                               @click="removeOrderKeys('imageAry', itl)"></el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="5">
                  <el-col :span="24">
                    <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                      <el-col :span="12" style="padding-left: 1rem;">
                        <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('imageAry')">
                          <i class="el-icon-plus"></i>
                          <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">添加淘口令</span><span v-else>添加关键词</span>
                        </el-button>
                      </el-col>
                      <el-col :span="12" style="line-height: 43px;">
                        <span>总计：<span style="color: red">{{ totalImageContent }}</span>单</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="taskReleaseForm.imageContent">
                  <el-col :span="24">
                    <el-row :gutter="2" align="middle" type="flex">
                      <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                        <span style="font-size: smaller;margin: 5px;">设置图文字好评内容</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0" class="contentCls" v-for="(submIt, index) in taskReleaseForm.imageContentAry"
                            :key="index">
                      <el-col :span="24">
                        <el-row :gutter="2">
                          <el-col :span="24"
                                  style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                            <span style="font-size: smaller;margin: 5px;">设置第{{ submIt.orderSort}}单文字好评内容</span>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="16">
                            <el-form-item label-width="1%">
                              <el-input v-model="submIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="20">
                            <el-form-item label-width="1%">
                              <el-input type="textarea" v-model="submIt.reviewContent"
                                        placeholder="(选填)完整的评价内容， 最多500个字。未填写则在买手端提醒买手自由发挥。"
                                        maxlength="500"
                                        show-word-limit></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="5" class="itemCls" style="margin-bottom: 10px;">
                          <el-col :span="4">
                            <el-form-item label-width="6%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:0})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isImageShow(submIt, 0)">
                                <img  :src="getImageUrl(submIt, 0)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(submIt, 0)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="6%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:1})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isImageShow(submIt, 1)">
                                  <img  :src="getImageUrl(submIt, 1)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(submIt, 1)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="6%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:2})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isImageShow(submIt, 2)">
                                  <img  :src="getImageUrl(submIt, 2)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(submIt, 2)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="6%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:3})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isImageShow(submIt, 3)">
                                  <img  :src="getImageUrl(submIt, 3)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(submIt, 3)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="6%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewSuccess.bind(null, {index: index, data:submIt, imgIndex:4})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isImageShow(submIt, 4)">
                                  <img  :src="getImageUrl(submIt, 4)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(submIt, 4)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="5" align="center" style="margin: 10px 0px;">
        <el-col :span="24">
          <el-row style="padding-left: 6.3%">
            <el-col :span="6" style="text-align: left;line-height: 20px;margin-right: 0.8rem">
              <el-checkbox v-model="taskReleaseForm.videoChecked" @change="taskChanged('videoAry')">指定视频好评任务(<span style="color: #04befe;margin: 2px;">{{getTaskClassMoney("20210004")}}</span>金/单)
              </el-checkbox>
            </el-col>
          </el-row>
          <el-row :gutter="2" v-if="taskReleaseForm.videoChecked"
                  style="border: 1px solid red;margin: 5px;margin-left: 2.1rem;">
            <el-col :span="24">
              <div>
                <el-row :gutter="0" class="keywordCls" align="middle" type="flex" v-for="(ita,index) in taskReleaseForm.videoAry" :key="index">
                  <el-col :span="6" v-show="!isQrcodeTask">
                    <el-form-item label="下单关键词" label-width="50%">
                        <span slot="label">
                          <span style="color: red; font-size:small">
                           必填
                          </span>
                        <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">淘口令</span><span v-else>下单关键词</span>
                        </span>
                      <el-input v-model="ita.orderKeys"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="添加单数" label-width="35%">
                      <el-input v-model="ita.orderAdd"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-show="!isQrcodeTask">
                    <el-form-item label="备用关键词" label-width="42%">
                      <el-input v-model="ita.orderBackKey" placeholder="(选填)备用关键词"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" style="padding-left: 3%;text-align: right" v-if="ita.isShowRemove">
                    <el-button type="danger" icon="el-icon-delete" circle size="mini"
                               @click="removeOrderKeys('videoAry', ita)"></el-button>
                  </el-col>
                </el-row>
                <el-row :gutter="5">
                  <el-col :span="24">
                    <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
                      <el-col :span="12" style="padding-left: 1rem;">
                        <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('videoAry')">
                          <i class="el-icon-plus"></i>
                          <span v-if="isTaoTagOrder(taskReleaseForm.taskType)">添加淘口令</span><span v-else>添加关键词</span>
                        </el-button>
                      </el-col>
                      <el-col :span="12" style="line-height: 43px;">
                        <span>总计：<span style="color: red">{{ totalVideoContent }}</span>单</span>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="taskReleaseForm.videoContent">
                  <el-col :span="24">
                    <el-row :gutter="2" align="middle" type="flex">
                      <el-col :span="24" style="background-color: mistyrose;max-height: 30px;margin: 5px;">
                        <span style="font-size: smaller;margin: 5px;">设置视频好评内容</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="0" class="contentCls" v-for="(subvIt, index) in taskReleaseForm.videoContentAry"
                            :key="index">
                      <el-col :span="24">
                        <el-row :gutter="2">
                          <el-col :span="24"
                                  style="background-color: mistyrose;max-height: 30px;margin: 5px;width: 99%;">
                            <span style="font-size: smaller;margin: 5px;">设置第{{ subvIt.orderSort}}单文字好评内容</span>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="16">
                            <el-form-item label-width="1%">
                              <el-input v-model="subvIt.orderColorSize" placeholder="(选填)颜色尺码"></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0">
                          <el-col :span="20">
                            <el-form-item label-width="1%">
                              <el-input type="textarea" v-model="subvIt.reviewContent"
                                        placeholder="(选填)完整的评价内容， 最多500个字。未填写则在买手端提醒买手自由发挥。"
                                        maxlength="500"
                                        show-word-limit></el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0" class="itemCls">
                          <el-col :span="24" id="videoTag">
                            <el-form-item label-width="1%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="video/mp4"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:0})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 0)" style="line-height: initial;">
                                <video  width="220" height="220" controls>
                                  <source :src="getVideoUrl(subvIt, 0)" type="video/mp4">
                                </video>
                                <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 0)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="0" class="itemCls" style="margin-bottom: 10px;">
                          <el-col :span="4">
                            <el-form-item label-width="4%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:1})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 1)">
                                  <img :src="getVideoUrl(subvIt, 1)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 1)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="4%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:2})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 2)">
                                  <img :src="getVideoUrl(subvIt, 2)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 2)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="4%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:3})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 3)" >
                                  <img :src="getVideoUrl(subvIt, 3)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 3)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="4%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:4})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 4)">
                                  <img :src="getVideoUrl(subvIt, 4)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 4)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item label-width="4%">
                              <el-upload
                                  action="https://api.weiquanai.com/taskservice/file/upload"
                                  :headers="myheader"
                                  :show-file-list="false"
                                  accept="image/png,image/gif,image/jpg,image/jpeg"
                                  :on-success="handleReviewVideoSuccess.bind(null, {index: index, data:subvIt, videoIndex:5})"
                                  :on-remove="handleAvatarRemove">
                                <div v-if="isVideoShow(subvIt, 5)">
                                  <img :src="getVideoUrl(subvIt, 5)" class="avatar">
                                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveTask(subvIt, 5)"></i>
                                </div>
                                <i v-else class="el-icon-plus"></i>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      </div>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">发布时间设置</span>
      </div>
      <el-row :gutter="5">
        <el-col :span="20" style="margin-top: 5px;" class="a">
          <el-form-item label="时间类型" prop="selectTimeModel" label-width="19%">
              <span slot="label">
                <span style="color: red; font-size:small">必填</span>
                时间类型
              </span>
            <el-radio-group v-model="taskReleaseForm.selectTimeModel" @change="timeModelChange">
              <el-radio :label="0">间隔模式</el-radio>
              <el-radio :label="1">时间段模式</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="taskReleaseForm.modelTagShow">
        <el-row :gutter="0" style="margin-left: 1%">
          <el-col :span="24" style="color: red;font-size: 12px">
            <div>
              <span>计划放单总单数必须等于发布任务总量，间隔分钟等于0默认开始时间一到一起发布</span>
            </div>
            <div>
              <span>例1：开始时间
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>，每隔
                <span style="color: #1F9FFF">0</span>分钟放出
                <span style="color: #1F9FFF">10</span>单,共放
                <span style="color: #1F9FFF">10</span>单
              </span>
            </div>
            <div>
              <span>即
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>放出
                <span style="color: #1F9FFF">10</span>单
              </span>
            </div>
            <div>
              <span>例2：开始时间
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>，每隔
                <span style="color: #1F9FFF">30</span>分钟放出
                <span style="color: #1F9FFF">2</span>单，共放
                <span style="color: #1F9FFF">10</span>单
              </span>
            </div>
            <div>
              <span>即
                <span style="color: #1F9FFF">2019-01-01 10:00:00</span>开始，每
                <span style="color: #1F9FFF">30</span>分钟放
                <span style="color: #1F9FFF">2</span>单，共放
                <span style="color: #1F9FFF">10</span>单，放出明细如下：
              </span>
            </div>
            <div>
              <span>
                <span style="color: #1F9FFF">10:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">10:30:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">11:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">11:30:00</span>放出
                <span style="color: #1F9FFF">2</span>单，
                <span style="color: #1F9FFF">12:00:00</span>放出
                <span style="color: #1F9FFF">2</span>单
              </span>
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="2" style="border: 1px solid red;margin: 5px;">
          <el-col :span="24">
            <div>
              <el-row :gutter="0" class="keywordCls" align="middle" type="flex"
                      v-for="(planit, index) in taskReleaseForm.orderPlanAry" :key="planit">
                <el-col :span="10">
                  <el-form-item label="开始时间" label-width="30%">
                    <el-date-picker
                        v-model="planit.orderPlanTime"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间"
                        default-time="00:00:00">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="3">
                  <el-form-item label="每隔" label-width="40%">
                    <el-input v-model="planit.spaceMinute"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="分钟放出" label-width="58%">
                    <el-input v-model="planit.oplanNum"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="单，共放" label-width="58%">
                    <el-input v-model="planit.oplanTotal" @change="verifyTaskField"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <el-form-item label="单" label-width="8%">
                  </el-form-item>
                </el-col>
                <el-col :span="1" style="padding-left: 3%;text-align: right" v-if="planit.isShowRemove">
                  <el-button type="danger" icon="el-icon-delete" circle size="mini"
                             @click="removeOrderKeys('orderPlanAry', planit)"></el-button>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-row :gutter="2" style="line-height: 33px;margin-left: 3%;font-size: 1rem">
              <el-col :span="12" style="padding-left: 1rem;">
                <el-button type="text" style="color: red;font-size: 1rem;" @click="addOrderKeys('orderPlanAry')" :disabled="false">
                  <i class="el-icon-plus"></i>
                  添加放单计划
                </el-button>
              </el-col>
              <el-col :span="12" style="line-height: 43px;">
                <span>总计：<span style="color: red">{{ totalAllPlanNum || 0 }}/{{ totalContentCon }}</span>单</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <el-row :gutter="2">
          <el-col :span="24" style="color: red;font-size: 12px">
            <div>
              1.计划放单总单数必须等于发布任务总量，放单时间不能小于当前时间
            </div>
            <div>
              2.将按下列时间段，到点自动放单
            </div>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="0">
          <el-col :span="24" class="planCls">
            <el-row :gutter="2" style="margin-top: 2%">
              <el-col :span="10">
                <el-form-item label="开始时间" label-width="26%">
                  <el-date-picker
                      v-model="taskReleaseForm.planStartTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :picker-options="expireTimeOption"
                      placeholder="选择日期时间"
                      default-time="00:00:00">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="14" style="line-height: 40px">
                <span>总计：<span style="color: red">{{ totalAllHourNum }}/{{ totalContentCon }}</span>单</span>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row :gutter="2">
              <el-col :span="24">
                <el-row :gutter="2" style="margin: 0px 5px;">
                  <el-col :span="3" v-for="(hourIt, index) in getPlanSpaceData(0)" :key="index">
                    <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                      <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                size="small" v-model="hourIt.orderNum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="2" style="margin: 0px 5px;">
                  <el-col :span="3" v-for="(hourIt, index) in getPlanSpaceData(8)" :key="index">
                    <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                      <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                size="small" v-model="hourIt.orderNum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="2" style="margin: 0px 5px;">
                  <el-col :span="3" v-for="(hourIt, index) in getPlanSpaceData(16)" :key="index">
                    <el-form-item :label="hourIt.hour.toString().concat('点')" label-width="38%">
                      <el-input :disabled="isDisabled(hourIt.hour)" type="text"
                                onkeyup="value=value.replace(/[^\d]/g,'')"
                                size="small" v-model="hourIt.orderNum"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <el-divider></el-divider>
      <el-row :gutter="5" type="flex" justify="start" style="padding-left: 6.3%; margin: 10px 0px" v-show="isShowAfterDays(taskReleaseForm.taskType)">
        <el-col :span="12">
          <div class="afterdayclass">
            <div style="font-size: small;"><span style="color: red; font-size:small">必填 </span> 购买开始时间</div>
            <el-date-picker
                v-model="taskReleaseForm.buyBeginTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                default-time="00:00:00">
            </el-date-picker>
            <div style="font-size: small;color: darkgrey;">（买家可以在指定日期后开始付款）</div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="afterdayclass">
            <div style="font-size: small;">购买结束时间</div>
            <el-date-picker
                v-model="taskReleaseForm.buyEndTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
                default-time="00:00:00">
            </el-date-picker>
            <div style="font-size: small;color: darkgrey;">（买家在指定日期后不再允许付款,且订单被取消）</div>
          </div>
        </el-col>
      </el-row>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">选择增值服务</span>
      </div>
      <service-attarch-component ref="childdata" @queryMoreLinkPrice="getMoreLinkPrice" :taskTypeId="taskReleaseForm.taskType"></service-attarch-component>
      <el-divider></el-divider>
      <div class="clearfix"
           style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
        <span style="color: #FFFFFF; font-size: 1rem">商家附加要求</span>
      </div>
      <el-row>
        <el-col :span="24">
          <el-row>
            <el-col :span="24">
              <span style="color: red; font-size: 0.8rem">如有需要备注可添加图片，最多可添加3张，图片中不要显示店铺名或商品名，避免用户直接搜索！</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 2%;">
            <el-col :span="8">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleB2cAttarchSuccess.bind(null, {index:0})"
                  :on-remove="handleAvatarRemove">
                <div v-if="taskReleaseForm.firstImageUrl">
                <img :src="taskReleaseForm.firstImageUrl" class="avatar">
                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveAttr(taskReleaseForm)"></i>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="8">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleB2cAttarchSuccess.bind(null, {index:1})"
                  :on-remove="handleAvatarRemove">
                <div v-if="taskReleaseForm.secondImageUrl">
                  <img :src="taskReleaseForm.secondImageUrl" class="avatar">
                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveAttr(taskReleaseForm)"></i>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
            <el-col :span="8">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleB2cAttarchSuccess.bind(null, {index:2})"
                  :on-remove="handleAvatarRemove">
                <div v-if="taskReleaseForm.thirdImageUrl">
                  <img :src="taskReleaseForm.thirdImageUrl" class="avatar">
                  <i class="el-icon-delete" style="z-index: 999" @click.stop="handleAvatarRemoveAttr(taskReleaseForm)"></i>
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-row>
          <el-row style="margin-top: 2%;">
            <el-col :span="24">
              <span style="color: red; font-size: 0.8rem">商家备注内容</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 2%;">
            <el-col :span="24">
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="重要！如果对用户有特别的要求，请在备注里注明，用户在做任务时会看到， 最多不能超过300字（任务备注只是商家要求，我们只能做到传达给用户但不会强制用户按要求执行）"
                  v-model="taskReleaseForm.remarksContent"
                  maxlength="300"
                  show-word-limit>
              </el-input>
            </el-col>
          </el-row>
        </el-col>
      </el-row> -->
    </el-form>
    <div class="dialog-footer">
      <el-button @click="submitDataToNext()" size="mini" type="primary">下一步</el-button>
    </div>
  </el-card>

  <el-dialog title="任务发布信息确认" :visible.sync="dialogFormConfirmVisible">
    <div class="clearfix"
         style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
      <span style="color: #FFFFFF; font-size: 1rem">任务信息</span>
    </div>
    <el-table :data="dialogFormConfirm"
              style="width: 100%">
      <el-table-column prop="taskType" label="类型">
      </el-table-column>
      <el-table-column prop="shopInfo" label="店铺">
      </el-table-column>
      <el-table-column prop="returnMoneyType" label="返款">
      </el-table-column>
      <el-table-column prop="goodTitle" label="商品标题">
      </el-table-column>
    </el-table>
    <div class="clearfix"
         style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
      <span style="color: #FFFFFF; font-size: 1rem">收费明细</span>
    </div>
    <div class="clearfix"
         style="border-style: none;background-color: lightgray;height: 33px;text-align: center;line-height: 33px;margin-bottom: 0.8rem;">
      <div style="color: red;font-size: 0.6rem;text-align: right;margin-right: 20%;">注:由于收付款系统需要加收服务费，因此每单收取相应金额返款手续费,费用参考明细中手续费。</div>
    </div>
    <el-table :data="dialogFormConfirm[0].moneyDetails"
              show-summary
              style="width: 100%">
      <el-table-column prop="taskClass" label="类型">
      </el-table-column>
      <el-table-column prop="moneyFree" label="本金">
      </el-table-column>
      <el-table-column prop="baseServiceMoney" label="基础服务费">
      </el-table-column>
      <el-table-column prop="attachMoney" label="附加服务费">
      </el-table-column>
      <el-table-column prop="reviewServiceMoney" label="评分服务费">
      </el-table-column>
      <!--<el-table-column prop="moneyReward" label="赏金">
      </el-table-column>-->
      <el-table-column prop="expressMoney" label="运费">
      </el-table-column>
      <el-table-column prop="serviceFee" label="手续费">
      </el-table-column>
      <el-table-column prop="taskNumbers" label="任务数">
      </el-table-column>
      <el-table-column prop="totalMoney" label="小计">
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button @click="confirmRelease" size="medium" type="primary" :disabled="releaseBtnClickEnable">确认发布</el-button>
      <el-button @click="saveWaitPay" size="mini" :disabled="releaseBtnClickEnable">保存待支付</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from "../../components/MixinCUD";
import VDistpicker from "v-distpicker";
import ServiceAttarchComponent from "../b2ccomponents/ServiceAttarchComponent";
import {planData} from "../../lib/orderPlanData";
import {getAllTaskType} from "../../api/b2cbusiness/b2c_tasktype";
import {getJwtToken} from "../../lib/utils";
import {getUserListExpress} from "../../api/b2cbusiness/b2c_express";
import {getTaskRelaseShops} from "../../api/b2cbusiness/b2c_shopmanage";
import {
  addTask, cancelTaskRelease,
  confirmTaskRelease,
  getTaobaoGoodInfo,
  getTaskVoInfo, queryTaskClassMoneys,
  queryTaskVo
} from "../../api/b2cbusiness/b2c_tasklist";
import {province} from "../../lib/province";
import {queryStoreBusinessSetting} from "@/api/b2cbusiness/storelist";

export default {
 name: "BusinessTaskRelease",
  mixins: [MixinCUD],
  components: {
    VDistpicker,
    ServiceAttarchComponent
  },
  data(){
   return {
     expireTimeOption: {
       disabledDate(date) {
         //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
         return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
       }
     },
     myheader: {
       JWTHeaderName: ""
     },
     timeLineHeight: 850,
     options: [],
     allShops: [],
     allExpress: [],
     allTaskClassMoneys:[],
     moreLinkPrice: 0.00, //多商品链接单价
     releaseBtnClickEnable: false, //新增按钮点击发布或者保存后， 待后台发挥才可以再点击
     enableBusinessReturnMoney: false, //新增判断是否有商返权限
     taskReleaseForm: {
       taskType: null,
       shopInfo: null,
       baseMoneyReturnType: 0, //返款对象
       taskName: "",
       productUrl: "",
       goodTitle: "",
       goodImgUrl: "",
       businessPrice: "",
       billProductNum: "1",
       sreachPrice: "",
       goodPriceTotal: 0,
       goodsAry: [],
       couponUrl: "",   //优惠券链接
       freeShipping: true, //是否包邮
       logisticsCompany: "", //物流公司
       goodsSortType: 0, //商品排序的方式
       qrcodeTaskImgUrl:null, //二维码任务的二维码图片地址
       douyinAccount: null, //抖音号
       douyinImgUrl: null, //抖音二维码
       douyinKeyword: null, //抖音关键字
       recivePersons: "", //商品现有收货人
       startPrice: "", //价格区间-价格起步
       endPrice: "", //价格区间-价格终点
       goodAddress: "", //商品所在地
       goodInfoAnswer: "", //宝贝详情问答
       orderLeaveMessage: "", //订单留言
       taskChecked: false,
       orderNums: "",
       taskAry: [
         {
           taskOrderType: "",
           orderKeys: "",
           orderAdd: "",
           orderBackKey: "",
           orderColorSize: "",
           isShowRemove: false
         },
       ],
       taskReviewChecked: false,
       textChecked: false,
       textOrdNum: 0,
       textAry: [
         {
           orderKeys: "",
           orderAdd: "",
           orderBackKey: "",
           isShowRemove: false
         },
       ],
       textContent: false,
       textContentCon: 0,
       textContentAry: [],
       imageChecked: false,
       imageOrdNum: "",
       imageAry: [
         {
           orderKeys: "",
           orderAdd: "",
           orderBackKey: "",
           isShowRemove: false
         },
       ],
       imageContent: false,
       imageContentCon: 0,
       imageContentAry: [],
       videoChecked: false,
       videoOrdNum: "",
       videoAry: [
         {
           orderKeys: "",
           orderAdd: "",
           orderBackKey: "",
           isShowRemove: false
         },
       ],
       videoContent: false,
       videoContentCon: 0,
       videoContentAry: [],
       buyBeginTime: "",
       buyEndTime: "",
       totalAllOrderNum: 0,
       selectTimeModel: 0,
       modelTagShow: true,
       orderPlanAry: [
         {
           orderPlanTime: "",
           spaceMinute: "",
           oplanNum: "",
           oplanTotal: "",
           isShowRemove: false
         },
       ],
       planStartTime: "",
       detail: [...planData],
       businessAttarchQuest: "",
       firstImageUrl: "",
       secondImageUrl: "",
       thirdImageUrl: "",
       remarksContent: ""
     },
     dialogFormConfirmVisible: false,
     dialogFormConfirm: [
       {
         moneyDetails: []
       }
     ],
   }
  },
  mounted() {
   this.timeLineHeight = document.documentElement.clientHeight - 140;
   window.onresize = () =>{
     this.timeLineHeight = document.documentElement.clientHeight - 140;
   }
   this.addCachActive();
    if (this.$route.query.releaseData != null){
      console.log(this.$route.query.releaseData)
      this.buildReleaseDataFormTaskItem(this.$route.query.releaseData);
    }
    getAllTaskType().then(res => {
      console.log(res.data)
      this.options = res.data;
    });

    //获取商返的权限
    queryStoreBusinessSetting({}, {pageNum:1, pageSize:20}).then(res=>{
      if (res.success && res.data.records.length>0){
        this.enableBusinessReturnMoney = res.data.records[0].enableBusinessReturnMoney
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });

    this.myheader.JWTHeaderName = getJwtToken();

    getUserListExpress().then(res => {
      console.log(res.data)
      this.allExpress = res.data;
    });

    queryTaskClassMoneys().then(res => {
      this.allTaskClassMoneys = res.data;
    });

    if (this.$route.query.b2cTaskId != null){
      queryTaskVo({b2cTaskId:this.$route.query.b2cTaskId}).then(res=>{
        if (res.success){
          this.taskReleaseForm = res.data;
          this.timeModelChange();
          this.taskReleaseForm.taskType = parseInt(this.taskReleaseForm.taskType);
          getTaskRelaseShops(this.taskReleaseForm.taskType).then(res => {
            console.log(res.data);
            this.allShops = res.data;
            this.taskReleaseForm.shopInfo = this.taskReleaseForm.shopInfo.toString();
          });
          this.taskReleaseForm.serviceAttarch.provinces = [...province];
          this.$refs.childdata.childdata = this.taskReleaseForm.serviceAttarch;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  },
  activated() {
    if (this.$route.query.b2cTaskId != null){
      queryTaskVo({b2cTaskId:this.$route.query.b2cTaskId}).then(res=>{
        if (res.success){
          this.taskReleaseForm = res.data;
          //增加判断多链接是否有商品，有的话需要显示
          if (this.taskReleaseForm.goodsAry.length > 0){
            this.goodsTableVisible = true;
          }
          this.timeModelChange();
          this.taskReleaseForm.taskType = parseInt(this.taskReleaseForm.taskType);
          getTaskRelaseShops(this.taskReleaseForm.taskType).then(res => {
            console.log(res.data);
            this.allShops = res.data;
            this.taskReleaseForm.shopInfo = this.taskReleaseForm.shopInfo.toString();
          });
          this.taskReleaseForm.serviceAttarch.provinces = [...province];
          this.$refs.childdata.childdata = this.taskReleaseForm.serviceAttarch;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  },
  computed:{
    getTaskClassMoney(){
      return function (taskClass) {
        let taskClassObj = this.allTaskClassMoneys.find(obj=>obj.taskClass == taskClass);
        return taskClassObj != null? taskClassObj.serviceMoney:0.0;
      }
    },
    isImageShow() {
      return function (val, index) {
        if (val.imageUrls != undefined && val.imageUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getImageUrl() {
      return function (val, index) {
        console.log(val, index);
        if (val.imageUrls != undefined && val.imageUrls.length > 0) {
          return val.imageUrls[index];
        }
        return null;
      }
    },
    isVideoShow() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > index) {
          return true;
        }
        return false;
      }
    },
    getVideoUrl() {
      return function (val, index) {
        if (val.videoUrls != undefined && val.videoUrls.length > 0) {
          return val.videoUrls[index];
        }
        return null;
      }
    },
    isShowGetLinkBtn(){
      if (this.allShops != null
          && this.allShops.length > 0){
        return this.allShops[0].shopTypeId == 1;
      }else{
        return false;
      }
    },

    isShowAfterDays(){
      return function (taskTypeId) {
        return taskTypeId == 3
      }
    },

    isNotBrowserOrder(){
      return function (taskTypeId) {
        return taskTypeId != 4
      }
    },

    isNotDouyinOrder(){
      return function (taskTypeId) {
        return taskTypeId != 7 && taskTypeId != 18
      }
    },

    isTaoTagOrder(){
      return function (taskTypeId) {
        return taskTypeId == 16
      }
    },

    isQrcodeTask(){
      return this.taskReleaseForm.taskType == 11 || this.taskReleaseForm.taskType == 12 || this.taskReleaseForm.taskType == 7 || this.taskReleaseForm.taskType == 18;
    },

    totalTaskContent: function () {
      if (this.taskReleaseForm.taskAry.length > 0) {
        let con = 0;
        for (let i in this.taskReleaseForm.taskAry) {
          let a = this.taskReleaseForm.taskAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.taskReleaseForm.orderNums = con;
      } else {
        this.taskReleaseForm.orderNums = 0;
      }
      return this.taskReleaseForm.orderNums;
    },
    totalTextContent: function () {
      if (this.taskReleaseForm.textAry.length > 0) {
        let con = 0;
        for (let i in this.taskReleaseForm.textAry) {
          let a = this.taskReleaseForm.textAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.taskReleaseForm.textContentCon = con;
        this.taskReleaseForm.textContent = true;
      } else {
        console.log(this.taskReleaseForm.textContent);
        this.taskReleaseForm.textContent = false;
      }

      if (this.taskReleaseForm.textContent && this.taskReleaseForm.textContentCon > 0) {
        if (this.taskReleaseForm.textContentAry == null){
          this.taskReleaseForm.textContentAry = new Array();
        }
        //这个地方需要改造。 需要从0开始向上增加， 不能从上往下减
        let con = this.taskReleaseForm.textContentCon - this.taskReleaseForm.textContentAry.length;
        //新增一个计数变量
        let orderSort = this.taskReleaseForm.textContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.taskReleaseForm.textContentAry.push({
              orderSort: con + orderSort,
              orderColorSize: "",
              reviewContent: ""
            });
            con = con - 1;
          }
          this.taskReleaseForm.textContentAry.sort((a, b)=>a.orderSort-b.orderSort);
        } else {
          let removeCon = this.taskReleaseForm.textContentAry.length - this.taskReleaseForm.textContentCon;
          this.taskReleaseForm.textContentAry.splice(this.taskReleaseForm.textContentAry.length-removeCon, removeCon);
        }
      }
      if (this.taskReleaseForm.textContentCon <= 0) {
        this.taskReleaseForm.textContent = false;
      }
      return this.taskReleaseForm.textContentCon;
    },
    totalImageContent: function () {
      if (this.taskReleaseForm.imageAry.length > 0) {
        let con = 0;
        for (let i in this.taskReleaseForm.imageAry) {
          let a = this.taskReleaseForm.imageAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.taskReleaseForm.imageContentCon = con;
        this.taskReleaseForm.imageContent = true;
      } else {
        this.taskReleaseForm.imageContent = false;
      }

      if (this.taskReleaseForm.imageContent && this.taskReleaseForm.imageContentCon > 0) {
        if (this.taskReleaseForm.imageContentAry == null){
          this.taskReleaseForm.imageContentAry = new Array();
        }

        let con = this.taskReleaseForm.imageContentCon - this.taskReleaseForm.imageContentAry.length;
        //新增一个计数变量
        let orderSort = this.taskReleaseForm.imageContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.taskReleaseForm.imageContentAry.push({
              orderSort: con + orderSort,
              orderColorSize: "",
              imageUrls: [],
              reviewContent: ""
            });
            this.taskReleaseForm.imageContentAry.sort((a, b)=>a.orderSort-b.orderSort);
            con = con - 1;
          }
        } else {
          let removeCon = this.taskReleaseForm.imageContentAry.length - this.taskReleaseForm.imageContentCon;
          this.taskReleaseForm.imageContentAry.splice(this.taskReleaseForm.imageContentAry.length-removeCon, removeCon);
        }
      }
      if (this.taskReleaseForm.imageContentCon <= 0) {
        this.taskReleaseForm.imageContent = false;
      }
      return this.taskReleaseForm.imageContentCon;
    },
    totalVideoContent: function () {
      if (this.taskReleaseForm.videoAry.length > 0) {
        let con = 0;
        for (let i in this.taskReleaseForm.videoAry) {
          let a = this.taskReleaseForm.videoAry[i];
          if (a.orderAdd != null && a.orderAdd != "") {
            con = con + parseInt(a.orderAdd);
          }
        }
        this.taskReleaseForm.videoContentCon = con;
        this.taskReleaseForm.videoContent = true;
      } else {
        this.taskReleaseForm.videoContent = false;
      }

      if (this.taskReleaseForm.videoContent && this.taskReleaseForm.videoContentCon > 0) {
        if (this.taskReleaseForm.videoContentAry == null){
          this.taskReleaseForm.videoContentAry = new Array();
        }

        let con = this.taskReleaseForm.videoContentCon - this.taskReleaseForm.videoContentAry.length;
        //新增一个计数变量
        let orderSort = this.taskReleaseForm.videoContentAry.length;
        if (con > 0) {
          while (con > 0) {
            this.taskReleaseForm.videoContentAry.push({
              orderSort: con + orderSort,
              orderColorSize: "",
              videoUrls: [],
              reviewContent: ""
            });
            this.taskReleaseForm.videoContentAry.sort((a, b)=>a.orderSort-b.orderSort);
            con = con - 1;
          }
        } else {
          let removeCon = this.taskReleaseForm.videoContentAry.length - this.taskReleaseForm.videoContentCon;
          this.taskReleaseForm.videoContentAry.splice(this.taskReleaseForm.videoContentAry.length-removeCon, removeCon);
        }
      }
      if (this.taskReleaseForm.videoContentCon <= 0) {
        this.taskReleaseForm.videoContent = false;
      }
      return this.taskReleaseForm.videoContentCon;
    },
    totalContentCon: function () {
      this.taskReleaseForm.totalAllOrderNum = (parseInt(this.taskReleaseForm.orderNums) || 0) + (parseInt(this.taskReleaseForm.textContentCon) || 0) + (parseInt(this.taskReleaseForm.imageContentCon) || 0)
          + (parseInt(this.taskReleaseForm.videoContentCon) || 0);
      return this.taskReleaseForm.totalAllOrderNum;
    },
    totalAllPlanNum: function () {
      if (this.taskReleaseForm.orderPlanAry != null
          && this.taskReleaseForm.orderPlanAry.length > 0) {
        let planNum = 0;
        for (let item in this.taskReleaseForm.orderPlanAry) {
          planNum += parseInt(this.taskReleaseForm.orderPlanAry[item].oplanTotal)
        }
        if (planNum > this.taskReleaseForm.totalAllOrderNum) {
          this.$message({message: "放单计划数量大于任务数量，重新填写", type: 'error'});
          for (let item in this.taskReleaseForm.orderPlanAry) {
            this.taskReleaseForm.orderPlanAry[item].oplanTotal = 0;
          }
          return 0;
        }
        return planNum;
      }
      if (this.taskReleaseForm.totalAllPlanNum != null){
        return this.taskReleaseForm.totalAllPlanNum;
      }
      return 0;
    },
    totalAllHourNum: function () {
      if (this.taskReleaseForm.detail != null && this.taskReleaseForm.detail.length > 0) {
        let planNum = 0;
        for (let item in this.taskReleaseForm.detail) {
          if (this.taskReleaseForm.detail[item].orderNum != null && this.taskReleaseForm.detail[item].orderNum != "") {
            planNum += parseInt(this.taskReleaseForm.detail[item].orderNum);
          }
        }
        if (planNum > this.taskReleaseForm.totalAllOrderNum) {
          this.$message({message: "放单计划数量大于任务数量，重新填写", type: 'error'});
          for (let item in this.taskReleaseForm.detail) {
            this.taskReleaseForm.detail[item].orderNum = 0;
          }
          return 0;
        }
        return planNum;
      }
      return 0;
    },
  },
  watch:{
    'taskReleaseForm.goodsAry':{
      handler(oldVal, newVal){
        let totalTmpMoney = 0.0;
        for (let i in newVal){
          totalTmpMoney = totalTmpMoney + newVal[i].goodPrice*newVal[i].goodNum;
        }

        this.taskReleaseForm.goodPriceTotal = totalTmpMoney;
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    addCachActive() {
      this.$emit("changeInclude", this);
    },
    getMoreLinkPrice(val){
      console.log(val)
      this.moreLinkPrice = val;
    },
    buildReleaseDataFormTaskItem(data){
      this.taskReleaseForm.taskType = data.taskType;
      this.taskReleaseForm.shopInfo = data.shopInfo;
    },
    confirmRelease() {
      this.releaseBtnClickEnable = true;
      confirmTaskRelease(this.dialogFormConfirm[0]).then(res=>{
        if (res.success){
          this.releaseBtnClickEnable = false;
          this.dialogFormConfirmVisible = false;
          this.$message.success("发布成功！");
          this.$store.commit("removeTab", "/home/taskrelease");
          this.$router.go(-1);
        }
      }).catch(err => {
        this.releaseBtnClickEnable = false;
        this.$message({message: err.message, type: 'error'});
      });
    },
    saveWaitPay() {
      this.releaseBtnClickEnable = true;
      cancelTaskRelease(this.dialogFormConfirm[0]).then(res=>{
        if (res.success){
          this.releaseBtnClickEnable = false;
          this.dialogFormConfirmVisible = false;
          this.$router.go(-1);
          this.$store.commit("removeTab", "/home/taskrelease");
        }
      }).catch(err => {
        this.releaseBtnClickEnable = false;
        this.$message({message: err.message, type: 'error'});
      });
    },
    addData() {
      //this.taskReleaseForm.serviceAttarch = this.$refs.childdata.childdata;
      //fixbug 验证发布任务和时间计划之间的订单数不一致的问题。
      // if ((this.totalAllPlanNum > 0 && this.totalAllPlanNum != this.totalContentCon)
      //     ||(this.totalAllHourNum > 0 && this.totalAllHourNum != this.totalContentCon)){
      //   this.$message.error("放单计划的单数与任务中订单总数不一致，请检查！");
      // }else{
        //console.log(this.taskReleaseForm.serviceAttarch)
        addTask(this.taskReleaseForm).then(res => {
          //this.$message.success("成功发布任务");
          //this.submitQueryForm();//新增之后，重新查询table
          //this.handleCloseDialog();
          getTaskVoInfo(res.data.id).then(res => {
            this.dialogFormConfirmVisible = true;
            this.dialogFormConfirm = res.data;
            //console.log(this.dialogFormConfirm);
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      // }
    },
    verifyTaskField(){
      for (let item of this.taskReleaseForm.orderPlanAry){
        if (item.oplanNum <= item.oplanTotal && item.oplanNum > 0){
          continue
        }else{
          this.$message({message: "单次放单数量不能大于总数，小于0", type: 'error'});
          item.oplanNum = item.oplanTotal
          return false;
        }
      }
      return true;
    },
    submitDataToNext(){
      this.addData();
    },
    isDisabled(hour) {
      let inputDate = new Date(this.taskReleaseForm.planStartTime);
      if (this.taskReleaseForm.planStartTime == null || this.taskReleaseForm.planStartTime == "") {
        return true;
      }
      let currentDate = new Date();
      if ((inputDate.getDay() == currentDate.getDay())
          && (hour <= currentDate.getHours())) {
        return true;
      }
      return false;
    },
    taskChanged(isChecked) {
      this.taskReleaseForm.taskAry = [];
      this.taskReleaseForm.orderNums = 0;

      this.taskReleaseForm.textAry = [];
      this.taskReleaseForm.textContentCon = 0;

      this.taskReleaseForm.imageAry = [];
      this.taskReleaseForm.imageContentCon = 0;

      this.taskReleaseForm.videoAry = [];
      this.taskReleaseForm.videoContentCon = 0;

      if (isChecked == "taskAry") {
        if (this.taskReleaseForm.taskChecked) {
          this.taskReleaseForm.textChecked = false;
          this.taskReleaseForm.textAry = [];
          this.taskReleaseForm.imageChecked = false;
          this.taskReleaseForm.imageAry = [];
          this.taskReleaseForm.videoChecked = false;
          this.taskReleaseForm.videoAry = [];
          this.taskReleaseForm.taskAry.push({
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            orderColorSize: "",
            isShowRemove: false
          });
        }
      } else if (isChecked == "textAry") {
        if (this.taskReleaseForm.textChecked) {
          this.taskReleaseForm.taskChecked = false;
          this.taskReleaseForm.taskAry = [];
          this.taskReleaseForm.imageChecked = false;
          this.taskReleaseForm.imageAry = [];
          this.taskReleaseForm.videoChecked = false;
          this.taskReleaseForm.videoAry = [];
          this.taskReleaseForm.textAry.push({
            orderSort: this.taskReleaseForm.textAry.length + 1,
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      } else if (isChecked == "imageAry") {
        if (this.taskReleaseForm.imageChecked) {
          this.taskReleaseForm.taskChecked = false;
          this.taskReleaseForm.taskAry = [];
          this.taskReleaseForm.textChecked = false;
          this.taskReleaseForm.textAry = [];
          this.taskReleaseForm.videoChecked = false;
          this.taskReleaseForm.videoAry = [];
          this.taskReleaseForm.imageAry.push({
            orderSort: this.taskReleaseForm.imageAry.length + 1,
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      } else if (isChecked == "videoAry") {
        if (this.taskReleaseForm.videoChecked) {
          this.taskReleaseForm.taskChecked = false;
          this.taskReleaseForm.taskAry = [];
          this.taskReleaseForm.textChecked = false;
          this.taskReleaseForm.textAry = [];
          this.taskReleaseForm.imageChecked = false;
          this.taskReleaseForm.imageAry = [];
          this.taskReleaseForm.videoAry.push({
            orderSort: this.taskReleaseForm.videoAry.length + 1,
            orderKeys: "",
            orderAdd: "",
            orderBackKey: "",
            isShowRemove: false
          },);
        }
      }
    },
    addOrderKeys(orderKeys) {
      if (orderKeys == "taskAry") {
        this.taskReleaseForm.taskAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          orderColorSize: "",
          isShowRemove: true
        });
      } else if (orderKeys == "textAry") {
        this.taskReleaseForm.textAry.push({
          orderSort: this.taskReleaseForm.textAry.length + 1,
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "imageAry") {
        this.taskReleaseForm.imageAry.push({
          orderSort: this.taskReleaseForm.imageAry.length + 1,
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "videoAry") {
        this.taskReleaseForm.videoAry.push({
          orderKeys: "",
          orderAdd: "",
          orderBackKey: "",
          isShowRemove: true
        });
      } else if (orderKeys == "orderPlanAry") {
        this.taskReleaseForm.orderPlanAry.push({
          orderSort: this.taskReleaseForm.videoAry.length + 1,
          orderPlanTime: "",
          spaceMinute: "",
          oplanNum: "",
          oplanTotal: "",
          isShowRemove: true
        });
      }
    },
    removeOrderKeys(orderKeys, obj) {
      if (orderKeys == "taskAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.taskReleaseForm.taskAry.indexOf(obj);
          if (this.taskReleaseForm.taskAry.length > 1) {
            this.taskReleaseForm.taskAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "textAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.taskReleaseForm.textAry.indexOf(obj);
          if (this.taskReleaseForm.textAry.length > 1) {
            this.taskReleaseForm.textAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "imageAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.taskReleaseForm.imageAry.indexOf(obj);
          if (this.taskReleaseForm.imageAry.length > 1) {
            this.taskReleaseForm.imageAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "videoAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.taskReleaseForm.videoAry.indexOf(obj);
          if (this.taskReleaseForm.videoAry.length > 1) {
            this.taskReleaseForm.videoAry.splice(index, 1);
          }
        });
      } else if (orderKeys == "orderPlanAry") {
        this.$confirm("确认删除？").then(_ => {
          let index = this.taskReleaseForm.orderPlanAry.indexOf(obj);
          if (this.taskReleaseForm.orderPlanAry.length > 1) {
            this.taskReleaseForm.orderPlanAry.splice(index, 1);
          }
        });
      }
    },
    timeModelChange() {
      if (this.taskReleaseForm.modelTagShow == null) {
        this.taskReleaseForm.modelTagShow = true;
      }
      this.taskReleaseForm.modelTagShow = !this.taskReleaseForm.modelTagShow;
      if (this.taskReleaseForm.modelTagShow) {
        this.taskReleaseForm.orderPlanAry = [];
        this.taskReleaseForm.orderPlanAry.push({
          orderPlanTime: "",
          spaceMinute: "",
          oplanNum: "",
          oplanTotal: "",
          isShowRemove: false
        });
      } else {
        this.taskReleaseForm.detail = [];
        this.taskReleaseForm.detail = [...planData];
      }
    },
    handleReviewSuccess(obj, res, file) {
      console.log(obj, res, file);
      if (this.taskReleaseForm.imageContentAry[obj.index].imageUrls.length < obj.imgIndex) {
        this.taskReleaseForm.imageContentAry[obj.index].imageUrls.push(res.data);
      } else {
        this.taskReleaseForm.imageContentAry[obj.index].imageUrls.splice(obj.imgIndex, 1, res.data);
      }
    },
    getPlanSpaceData(witchData) {
      console.log(witchData, this.taskReleaseForm.detail.slice(witchData, witchData + 8));
      return this.taskReleaseForm.detail.slice(witchData, witchData + 8);
    },
    handleReviewVideoSuccess(obj, res, file) {
      console.log(obj, res, file);
      if (this.taskReleaseForm.videoContentAry[obj.index].videoUrls.length < obj.videoIndex) {
        this.taskReleaseForm.videoContentAry[obj.index].videoUrls.push(res.data);
      } else {
        this.taskReleaseForm.videoContentAry[obj.index].videoUrls.splice(obj.videoIndex, 1, res.data);
      }
    },
    getTaobaoGood(good) {
      //console.log(good)
      if (good != null) {
        getTaobaoGoodInfo({productUrl:good.goodUrl, shopInfo:this.taskReleaseForm.shopInfo}).then(res => {
          //console.log(res.data);
          good.goodImageUrl = res.data.goodImage;
          good.goodTitle = res.data.goodTitle;
          good.goodPrice = res.data.businessPrice;
        });
      } else {
        getTaobaoGoodInfo(this.taskReleaseForm).then(res => {
          //console.log(res.data);
          this.taskReleaseForm.goodImgUrl = res.data.goodImage;
          this.taskReleaseForm.goodTitle = res.data.goodTitle;
          this.taskReleaseForm.businessPrice = res.data.businessPrice;
        });
      }
    },
    addShops() {
      console.log("1111111")
      this.$router.push('/home/storemanagelist');
    },
    addGoods() {
      if (this.taskReleaseForm.goodsAry.length < 5){
        this.goodsTableVisible = true;
        let goodInfo = {
          goodImageUrl: "",
          goodUrl: "",
          mainKey: "",
          goodTitle: "",
          goodPrice: "",
          goodNum: "",
          goodRule: ""
        };
        this.taskReleaseForm.goodsAry.push(goodInfo);
      }else{
        this.$message.error("商品最多只能添加5个！");
      }

    },
    removeGood(good) {
      this.$confirm("确认删除当前商品？").then(_ => {
        let index = this.taskReleaseForm.goodsAry.indexOf(good);
        this.taskReleaseForm.goodsAry.splice(index, 1);
        if (this.taskReleaseForm.goodsAry.length <= 0) {
          this.goodsTableVisible = false;
        }
      });
    },
    onProvinceSelected(val) {
      console.log(val);
      this.taskReleaseForm.goodAddress = val.province.value;
    },
    taskTypeChange(val){
      console.log(val)
      this.$refs.childdata.refrashData(val);
      getTaskRelaseShops(val).then(res => {
        console.log(res.data);
        this.allShops = res.data;
      });
    },
    handleGoodSuccess(obj, res, file) {
      console.log(obj, res, file);
      this.taskReleaseForm.goodsAry[obj.index].goodImageUrl = res.data;
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.taskReleaseForm.goodImgUrl = res.data;
    },
    handleQrcodeImageSuccess(res, file) {
      console.log(res, file);
      this.taskReleaseForm.qrcodeTaskImgUrl = res.data;
    },
    handleDouyinImageSuccess(res, file) {
      console.log(res, file);
      this.taskReleaseForm.douyinImgUrl = res.data;
    },
    handleAvatarRemove(file) {
      console.log(file)
      this.taskReleaseForm.goodImgUrl = null
    },
    handleAvatarRemoveAttr(obj){
      if (!isObjectEmpty(obj.firstImageUrl)){
        obj.firstImageUrl = null
      }

      if (!isObjectEmpty(obj.secondImageUrl)){
        obj.secondImageUrl = null
      }

      if (!isObjectEmpty(obj.thirdImageUrl)){
        obj.thirdImageUrl = null
      }
    },
    handleAvatarRemoveLink(file) {
      console.log(file)
      // this.taskReleaseForm.goodsAry.map((val) =>{
      //   console.log(val, file)
      //   if (val.goodImgUrl == file.goodImgUrl){
      //     val.goodImgUrl = null
      //   }
      // })
      file.goodImageUrl = null
    },
    handleAvatarRemoveQrcode(obj){
      obj.qrcodeTaskImgUrl  = null;
    },
    handleAvatarRemoveDouyin(obj){
      obj.douyinImgUrl  = null;
    },
    handleAvatarRemoveTask(obj, indx){
      //console.log("handleAvatarRemoveTask", obj, indx)
      if (obj.imageUrls != undefined && obj.imageUrls.length > 0) {
        obj.imageUrls.splice(indx, 1);
      }

      if (obj.videoUrls != undefined && obj.videoUrls.length > 0) {
        obj.videoUrls.splice(indx, 1);
      }
    },
    handleB2cAttarchSuccess(obj, res, file) {
      console.log(obj, res, file);
      let urlStr = res.data;
      if (obj.index == 0) {
        this.taskReleaseForm.firstImageUrl = urlStr;
      } else if (obj.index == 1) {

        this.taskReleaseForm.secondImageUrl = urlStr;
      } else {
        this.taskReleaseForm.thirdImageUrl = urlStr;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer{
  padding: 10px 20px 20px;
  text-align: right;
  box-sizing: border-box;
}

table tr td {
  border-right: 1px solid #04befe;
  border-bottom: 1px solid #04befe;
  width: 4.33%;
  text-align: center;
  margin: 5px;
}

.el-form {
  margin-top: 20px;
}

.titleCls {
  line-height: 30px;
  position: relative;
}

.titleCls span {
  vertical-align: middle;
}

.titleCls span:nth-child(2) {
  padding-left: 20px;
}

.titleCls span:nth-child(3) {
  padding-left: 20px;
}

.afterdayclass{
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: 18% 32% 50%;
  grid-template-rows: 1fr;
  justify-items: left;
  align-items: center;
}

.titleCls span:last-child {
  float: right;
  margin-top: 0.8%;
  padding-right: 20px;
  color: #F85554;
}

.item-card {
  margin-bottom: 20px;
}

/* 定义keyframe动画，命名为blink */
@keyframes blink {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

/* 添加兼容性前缀 */
@-webkit-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-moz-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-ms-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@-o-keyframes blink {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

/* 定义blink类*/
.blink {
  color: red;
  animation: blink 1s linear infinite;
  /* 其它浏览器兼容性前缀 */
  -webkit-animation: blink 1s linear infinite;
  -moz-animation: blink 1s linear infinite;
  -ms-animation: blink 1s linear infinite;
  -o-animation: blink 1s linear infinite;
}

.boxself {
  border: 1px solid red;
  margin-left: 28%;
  font-size: smaller;
  height: 100%;

  /deep/ .el-upload--picture-card {
    width: 100px;
    height: 100px;
  }

  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }

  /deep/ .avatar {
    width: 100px;
    height: 100px;
  }

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }

}

#videoTag {
  /deep/ .el-upload--picture-card {
    width: 220px;
    height: 220px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 220px;
    height: 220px;
    line-height: 220px;
  }

  /deep/ .avatar {
    width: 220px;
    height: 220px;
  }
}

.itemCls {
  /deep/ .el-upload--picture-card {
    width: 120px;
    height: 120px;
  }

  /deep/ .el-upload {
    border: 1px dashed gray;
    border-radius: 5px;
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    width: 120px;
    height: 120px;
    line-height: 120px;
  }

  /deep/ .avatar {
    width: 120px;
    height: 120px;
  }
}

.keywordCls {
  max-height: 30px;
  margin: 5px 2px;
  background-color: lightpink;

  .el-input /deep/ .el-input__inner {
    height: 28px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__label {
    font-size: smaller;
  }
}

.contentCls {
  border: 1px solid red;
  border-radius: 5px;
  margin: 5px;

  .el-form-item {
    margin-bottom: 0px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 1%;
  }
}

.a {
  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item /deep/ .el-form-item__label {
    margin: 2px;
  }

  .el-form-item /deep/ .el-form-item__content {
    margin: 2px;
  }
}

.planCls {
  border: 1px solid red;
  margin: 5px;

  .el-divider {
    margin: 8px 0;
    background: 0 0;
    border-top: 1px solid red;
  }

  .el-form-item {
    margin-bottom: 10px;
  }
}

.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}

</style>
